import { modifyState } from '~src/state';
import _ from 'lodash';
import { loadSelectQuotesCategories } from './loadSelectQuotesCategories';
import { getMetadata } from '~loader/loader-utils';
import { fetchEditorQuotes } from './fetchEditorQuotes';
import { displaySidebarQuotes } from './displaySidebarQuotes';

export const handleTabQuotes = async (
  forceFetch = false,
  lastSelectedCategory
) => {
  modifyState('currentSidebarTab', 'quotes');
  if (!window.editorConfig.sidebarQuotes.items || forceFetch) {
    const metadata = getMetadata();
    const { quotes } = await fetchEditorQuotes(forceFetch);
    const textsByCategory = _.groupBy(quotes.items, 'category');
    window.editorConfig.sidebarQuotes.items = textsByCategory;
    loadSelectQuotesCategories({
      select: '#select-categories-quotes',
      categories: Object.keys(textsByCategory),
      projectSelected: metadata.projectTypeName,
      eventSelected: metadata.templatesCategoryName,
      lastSelectedCategory,
    });
  }
  displaySidebarQuotes();
};
